import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('cmrf')
export class CMRFEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"appl_no"
  })
  applicationNo: string;  
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"prefix_name"
  })
  namePrefix: string;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"applicant_name"
  })
  applicantName: string;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"applicant_gender"
  })
  applicantGender: string;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"prefix_relation"
  })
  prefixRelation: string;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"f_or_h_name"
  })
  fatherOrHusbandName: string;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"nominee_relation"
  })
  nomineeRelation: string;
  @Column("int",{
    nullable:false,
    name:"nominee_age"
  })
  nomineeAge: number;
  @Column("varchar",{
        nullable:false,
        length:250,
        name:"village"
  })
  village:string;
  @Column("varchar",{
        nullable:false,
        length:250,
        name:"mandal"
  })
  mandal:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"district"
  })
  district:string;
  @Column({
    type:'date',
    nullable:false,
    name:"app_received_dt"
  })
  applicationReceivedDate:Date;
  @Column("varchar",{
      nullable:false,
      length:250,
      name:"mobile"
  })
  mobileNo:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"aadhar_no"
  })
  aadharNo:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"nominee_aadhar_no"
  })
  nomineeAadharNo:string;
  @Column("int",{
    nullable:false,
    name:"age"
  })
  age: number;
  @Column("varchar",{
  nullable:false,
  length:250,
  name:"house_no"
  })
  houseNo:string;
  @Column("varchar",{
  nullable:false,
  length:250,
  name:"pin_no"
  })
  pinNo:string;
  @Column("varchar",{
    nullable:true,
    length:250,
    name:"ration_incomecert_no"
  })
  RationOrIncomeNo:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"hospital_name"
  })
  hospitalName:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"hospital_no"
  })
  hospitalNo:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"disease"
  })
  disease:string;
  @Column({
    type:'date',
    nullable:true,
    name:"dod"
  })
  dod:Date;
  @Column({
    type:'varchar',
    nullable:true,
    length:250,
    name:"bill_amount"
  })
  finalBillAmount:string;
  @Column({
    type:'varchar',
    nullable:true,
    length:500,
    name:"bill_amount_inwords"
  })
  finalBillAmountInWords:string;
  @Column({
    type:'date',
    nullable:true,
    name:"file_sent_dt"
  })
  fileSentDate:Date;
  @Column({
    type:'date',
    nullable:true,
    name:"print_date"
  })
  printDate:Date;
  @Column({
    type:'varchar',
    nullable:true,
    length:500,
    name:"reference"
  })
  reference:string;
  @Column({
    type:'varchar',
    nullable:true,
    length:500,
    name:"remarks"
  })
  remarks:string;
  @Column("boolean",{
      nullable:false,
      default:false,               
      name:"cheque_received_or_not"
  })
  chequeReceivedOrNot:boolean;
  @Column({
    type:'varchar',
    nullable:true,
    length:500,
    name:"cheque_no"
  })
  chequeNo:string;
  @Column({
    type:'date',
    nullable:true,
    name:"date"
  })
  date:Date;
  @Column({
    type:'varchar',
    nullable:true,
    length:500,
    name:"rec_amount_from_cm"
  })
  receivedAmountFromCMOffice:string;
  @Column({
    type:'date',
    nullable:true,
    name:"cheque_distrubtion_dt"
  })
  chequeDistrubtionDate:Date;
  @Column("boolean",{
    nullable:false,
    default:true,               
    name:"status"
  })
  status:boolean;
  @CreateDateColumn({
        name: "created_at",
        type:"datetime"
  })
  createdAt: Date;
  @Column("int", {
        nullable: false,
        name: "created_user"
  })
  createdUser: number | null;
  @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
  })
  updatedAt: Date;
  @Column("int", {
        nullable: true,
        name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
          default:1,
          name: "version_flag"
  })
  versionFlag: number;   
   
}